import { green, grey, orange } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';

export type PackageCategory = {
  bgColor: string;
  defaultOccupancy: '1A' | '2A';
  labelColor: string;
  label: string;
};

const categoryColors = (swatch: Record<number, string>, shade: number) => ({
  bgColor: alpha(swatch[500], 0.06),
  labelColor: swatch[shade],
});

export const PACKAGE_CATEGORIES: Array<PackageCategory> = [
  { ...categoryColors(green, 700), defaultOccupancy: '2A', label: 'BASIC' },
  { ...categoryColors(grey, 600), defaultOccupancy: '2A', label: 'UPGRADE' },
  { ...categoryColors(orange, 700), defaultOccupancy: '1A', label: 'SOLO TRAVELLER' },
  { ...categoryColors(orange, 700), defaultOccupancy: '1A', label: 'SOLO UPGRADE' },
];

export const BASIC_CATEGORY_INDEX = 0;
export const UPGRADE_CATEGORY_INDEX = 1;
export const SOLO_CATEGORY_INDEX = 2;
export const SOLO_UPGRADE_CATEGORY_INDEX = 3;

export const MIN_LOS = 1;
export const MAX_LOS = 30;

export const CELL_SX = { py: 1 };

export const HEADER_SX = { ...CELL_SX, fontWeight: 600 };

export const GROUP_DIVIDER_SX = { borderLeft: 1, borderLeftColor: 'divider' };

export const groupStartSx = (index: number) => (index === 0 ? GROUP_DIVIDER_SX : undefined);

export const EXTRA_NIGHT_DIVIDER_SX = { borderLeft: '3px solid', borderLeftColor: orange[700] };

// Sticky cells need an opaque background, so the translucent category tint is layered over the paper colour.
export const stickyCellSx = (left: number, tint?: string) => ({
  ...CELL_SX,
  bgcolor: 'background.paper',
  backgroundImage: tint ? `linear-gradient(${tint}, ${tint})` : undefined,
  left,
  position: 'sticky' as const,
  zIndex: 1,
});
